import React, { useState } from 'react';
import { signUp, confirmSignUp } from '@aws-amplify/auth';
import {
  Container,
  Header,
  Form,
  FormField,
  Input,
  Button,
  Alert,
  SpaceBetween,
  Link
} from '@cloudscape-design/components';

export const SignUpForm = ({ onSwitchToLogin, onSuccess }) => {
  const [step, setStep] = useState('signup'); // 'signup' or 'confirm'
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmationCode, setConfirmationCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSignUp = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await signUp({
        username: email,
        password,
        options: {
          userAttributes: { email }
        }
      });
      setStep('confirm');
    } catch (err) {
      setError(err.message || 'Sign up failed');
    } finally {
      setLoading(false);
    }
  };

  const handleConfirm = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await confirmSignUp({
        username: email,
        confirmationCode
      });
      console.log('✅ Account confirmed successfully');
      onSuccess(); // This should trigger auth refresh
    } catch (err) {
      console.error('❌ Confirmation error:', err);
      setError(err.message || 'Confirmation failed');
    } finally {
      setLoading(false);
    }
  };

  if (step === 'confirm') {
    return (
      <Container
        header={<Header variant="h1" style={{ textAlign: 'center' }}>Confirm your account</Header>}
      >
        <form onSubmit={handleConfirm}>
          <SpaceBetween size="l">
            {error && (
              <Alert type="error" dismissible onDismiss={() => setError('')}>
                {error}
              </Alert>
            )}
            
            <Alert type="info">
              We sent a confirmation code to {email}. Enter it below to complete your registration.
            </Alert>

            <FormField label="Confirmation code">
              <Input
                value={confirmationCode}
                onChange={({ detail }) => setConfirmationCode(detail.value)}
                placeholder="Enter 6-digit code"
                required
              />
            </FormField>

            <Button
              variant="primary"
              loading={loading}
              formAction="submit"
            >
              Confirm account
            </Button>

            <Link onFollow={() => setStep('signup')}>
              Back to sign up
            </Link>
          </SpaceBetween>
        </form>
      </Container>
    );
  }

  return (
    <Container
      header={<Header variant="h1" style={{ textAlign: 'center' }}>Create ResearchIQ account</Header>}
    >
      <form onSubmit={handleSignUp}>
        <SpaceBetween size="l">
          {error && (
            <Alert type="error" dismissible onDismiss={() => setError('')}>
              {error}
            </Alert>
          )}
          
          <FormField label="Email">
            <Input
              value={email}
              onChange={({ detail }) => setEmail(detail.value)}
              type="email"
              required
            />
          </FormField>

          <FormField label="Password">
            <Input
              value={password}
              onChange={({ detail }) => setPassword(detail.value)}
              type="password"
              required
            />
          </FormField>

          <Button
            variant="primary"
            loading={loading}
            formAction="submit"
          >
            Create account
          </Button>

          <Link onFollow={onSwitchToLogin}>
            Already have an account? Sign in
          </Link>
        </SpaceBetween>
      </form>
    </Container>
  );
};
